module.exports = __webpack_public_path__ + "static/media/178288.22dc9cad.jpg";